import { render, staticRenderFns } from "./RecordInStatusXTimeReminderNotification.vue?vue&type=template&id=1de84cd2&scoped=true&"
import script from "./RecordInStatusXTimeReminderNotification.vue?vue&type=script&lang=js&"
export * from "./RecordInStatusXTimeReminderNotification.vue?vue&type=script&lang=js&"
import style0 from "./RecordInStatusXTimeReminderNotification.vue?vue&type=style&index=0&id=1de84cd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de84cd2",
  null
  
)

export default component.exports